import React from 'react';
import ExpandIcon from '../../assets/imgs/expand.svg';
import CopyIcon from '../../assets/imgs/copy.svg';
// import RedWarningIcon from '../../../../../assets/imgs/icons/warning-red.svg';
// import LockIcon from '../../assets/imgs/lock.svg';
type Props = {
	// isBotDeployed: 'true' | 'false' | undefined;
	encryptedBotId: string;
	redirectToExternalBot: Function;
	selectedBaseURL: string;
	// isBotPublic: true | false | undefined;
};

export default function SharePane(props: Props) {
	const [link, setLink] = React.useState('');
	const [isLinkCopied, setIsLinkCopied] = React.useState(false);

	React.useEffect(() => {
		let timer: any;
		//newly added
		if (isLinkCopied) {
			timer = setTimeout(setIsLinkCopied, 1000, false);
		}
		return () => clearTimeout(timer);
	}, [isLinkCopied]);

	React.useEffect(() => {
		var Environment = 'AwarePROD';
		if (props.selectedBaseURL === 'https://awareuat.senseforth.com') {
			Environment = 'AwarePreProdOld';
		} else if (
			props.selectedBaseURL === 'https://aware-preprod.senseforth.com'
		) {
			Environment = 'AwarePreProdNew';
		} else if (props.selectedBaseURL === 'https://flyfish.senseforth.com') {
			Environment = 'Flyfish';
		} else if (props.selectedBaseURL === 'https://flyfishuat.senseforth.com') {
			Environment = 'FlyfishUAT';
		}
		setLink(
			`${window.origin}/customer2/chatsdk.html?botID=${encodeURIComponent(
				props.encryptedBotId
			)}&env=${Environment}`
		);
	}, [props.encryptedBotId, props.selectedBaseURL]);

	function handleCopy() {
		if (navigator && navigator.clipboard) {
			navigator.clipboard
				.writeText(link)
				.then(
					() => setIsLinkCopied(true),
					(err) => console.info(err)
				)
				.catch((err) => console.error(err));
		}
	}
	return (
		<div className='share-pane-w' onClick={(e) => e.stopPropagation()}>
			{/* {props.isBotPublic === false ? (
        <div className='share-pane-info'>
          <img src={LockIcon} alt='private' title='Private' />
          <div>
            This bot is private. Please make it public from bot configurations to enable
            the shareable testing link.
          </div>
        </div>
      ) : ( */}
			<>
				{/* <div>Share the bot for testing</div>
        <div>
          Share this link with test users to collect and analyse their responses and
          feedback
        </div> */}
				<div className='get-ink-url'>
					<input
						value={link}
						onChange={(e) => e.preventDefault()}
						className='sf-link-preview'
					/>
					<img
						src={CopyIcon}
						alt='CopyIcon'
						className='clickable'
						onClick={handleCopy}
						title='Copy'
					/>
					<img
						src={ExpandIcon}
						alt='ExpandIcon'
						className='clickable'
						onClick={() => props.redirectToExternalBot()}
						title='Open'
					/>
					{/* {isLinkCopied ? <div className='sf-link-copied'>Link Copied</div> : null} */}
				</div>
				{/* {props.isBotDeployed === 'true' ? null : (
            <div>
              <img src={RedWarningIcon} alt='RedWarningIcon' /> */}
				{/* <div>
                The bot in testing link will not respond until you deploy a version of the
                bot.
              </div> */}
				{/* </div>
          )} */}
			</>
			{/* )} */}
		</div>
	);
}
